// extracted by mini-css-extract-plugin
export var notificationHost = "_mc-0";